import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-not-found',
    imports: [MatButtonModule, MatIconModule],
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
    title = input<string>('');
    description = input<string>('');
    addBtnText = input<string>('');
    showButton = input<boolean>(false);
    onAddAction = output<Event>();
    retryText = input<string>('');
    onRetryAction = output<Event>();

    public onAddBtn(e: Event): void {
        this.onAddAction.emit(e);
    }

    public onRetry(e: Event) {
        this.onRetryAction.emit(e);
    }
}
